import React, { useState } from 'react';
import { Shield, X, Loader2 } from '../DeskeyIcons';
import { Button } from './button';
import { Input } from './input';
import { toast } from 'sonner';

// Confirm a sensitive admin action (e.g. blocking a teacher) with a required
// reason. `onConfirm(reason)` performs the action and should throw on failure.
export function ReasonConfirmModal({ open, onClose, onConfirm, title, description, accent, confirmLabel }) {
  const A = accent || '#ef4444';
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleClose = () => { setReason(''); onClose(); };

  const handleConfirm = async () => {
    if (!reason.trim()) { toast.error('Please enter a reason'); return; }
    setSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason('');
    } catch {
      // onConfirm surfaces its own error toast; keep the modal open to retry.
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="reason-confirm-modal">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={handleClose} />
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center">
            <Shield className="w-4.5 h-4.5 text-red-500" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{title || 'Confirm action'}</h3>
            {description && <p className="text-[11px] text-slate-400">{description}</p>}
          </div>
          <button onClick={handleClose} className="w-7 h-7 rounded-lg hover:bg-slate-100 flex items-center justify-center" data-testid="reason-confirm-close">
            <X className="w-4 h-4 text-slate-400" />
          </button>
        </div>

        <div className="px-5 py-4 space-y-3">
          <div>
            <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1.5">Reason</label>
            <Input value={reason} onChange={e => setReason(e.target.value)} placeholder="Reason for this action..." className="h-10 rounded-lg text-sm" data-testid="reason-confirm-input" />
          </div>
          <Button onClick={handleConfirm} disabled={!reason.trim() || submitting} className="w-full h-10 rounded-lg text-white text-sm font-semibold" style={{ background: A }} data-testid="reason-confirm-btn">
            {submitting ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : null}
            {submitting ? 'Working...' : (confirmLabel || 'Confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
